module.exports = __webpack_public_path__ + "static/img/67 (3).29c8cb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/67 (3).jpg
// module id = Ws5a
// module chunks = 0